import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.stopPropagation)
  }

  disconnect() {
    this.element.removeEventListener('click', this.stopPropagation)
  }

  stopPropagation = (event) => {
    event.stopPropagation()
  }
} 